import { useState } from 'react'

import CircleIcon from '@/assets/icons/circle.svg?react'
import XMarkIcon from '@/assets/icons/x.svg?react'
import QuizHeader from '@/pages/gacha/steps/QuizStep/QuizHeader'
import type { QuizItem } from '@/types/quiz'

import { AnswerButton, ButtonRow, QuestionCard, QuestionImage, QuestionText, Ripple, StepWrapper } from './styles'

interface QuestionStepProps {
  quiz: QuizItem
  onAnswer: (selectedOptionIndex: number) => void
  isSubmitting?: boolean
}

export default function QuestionStep({ quiz, onAnswer, isSubmitting = false }: QuestionStepProps) {
  const [pressedIndex, setPressedIndex] = useState<number | null>(null)

  const handleClick = (index: number) => {
    if (pressedIndex !== null || isSubmitting) return
    setPressedIndex(index)
    onAnswer(index)
  }

  return (
    <StepWrapper>
      <QuizHeader />
      <QuestionCard>
        <QuestionText>{quiz.question.replace(/\\n/g, '\n')}</QuestionText>
        {quiz.imageUrl && (
          <QuestionImage src={quiz.imageUrl} alt='quiz-image' width={92} height={94} loading='eager' decoding='async' />
        )}
      </QuestionCard>
      <ButtonRow>
        <AnswerButton
          isCorrect={true}
          isPressed={pressedIndex === 0}
          onClick={() => handleClick(0)}
          disabled={isSubmitting && pressedIndex !== 0}
          aria-busy={(pressedIndex === 0 && isSubmitting) || undefined}
          aria-label='O 선택'>
          <CircleIcon width={28} height={28} />
          <Ripple className='ripple' />
        </AnswerButton>
        <AnswerButton
          isCorrect={false}
          isPressed={pressedIndex === 1}
          onClick={() => handleClick(1)}
          disabled={isSubmitting && pressedIndex !== 1}
          aria-busy={(pressedIndex === 1 && isSubmitting) || undefined}
          aria-label='X 선택'>
          <XMarkIcon width={32} height={32} />
          <Ripple className='ripple' />
        </AnswerButton>
      </ButtonRow>
    </StepWrapper>
  )
}
